import React, {Component} from 'react'
import {connect} from 'react-redux';

import {bindActionCreators} from "redux";


import {SignIn, CCActions, CCModalLayout} from './../../cc-imports'


class SignInModal extends Component {

    static propTypes = {}

    static defaultProps = {}

    constructor(props) {
        super(props)
        this.initialState = {
            fbLoading: false,
            gglLoading: false,
            emailLoading: false,

            error : null,

            email: '',
            password: '',
            displayName: ''
        }
        this.state = {
            showSignIn: true,
            ...this.initialState
        }

        this._closeModal = this._closeModal.bind(this);
    }

    _closeModal() {
        this.props.actions.closeModal("SignIn");
    }

    render() {
        return (
            <CCModalLayout name={"SignIn"}>
                <SignIn onSignInSuccess={this._closeModal}/>
            </CCModalLayout>
        )
    }
}

export default connect(state => ({
        modals: state.modals,
        user: state.user
    }),
    (dispatch) => ({
        actions: bindActionCreators({...CCActions}, dispatch),
        dispatch: dispatch
    })
)(SignInModal);


// WEBPACK FOOTER //
// ./src/app/modals/SignInModal/SignInModal.js